import { render, staticRenderFns } from "./AwsAccounts.vue?vue&type=template&id=2fbbdc32&"
import script from "./AwsAccounts.vue?vue&type=script&lang=js&"
export * from "./AwsAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports